module.exports = __webpack_public_path__ + "img/rep-it.bb28b3d2.png";